/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import {
    setErrorHandlerAction,
    SetErrorHandlerAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import { RootState } from 'types';
import { translate } from 'utils/translate';

import FormGroup from './FormGroup';
import Label from './Label';

interface UploadFileProps {
    language: string;
    acceptedFiles: string;
    url: string;
    children?: React.ReactNode;
    setErrorHandlerAction: SetErrorHandlerAction;
    showMessageAction: ShowMessageAction;
}

interface UploadFileState {
    item: Record<string, any>;
    errors: Record<string, any>;
}

class UploadFile extends Component<UploadFileProps, UploadFileState> {
    constructor(props: UploadFileProps) {
        super(props);

        this.state = {
            item: {},
            errors: {},
        };
    }

    // static getDerivedStateFromProps(nextProps: UploadFileProps, prevState: UploadFileState) {
    //     if (nextProps.item !== prevState.item || nextProps.errors !== prevState.errors) {
    //         return { item: nextProps.item, errors: nextProps.errors };
    //     }
    //     return null;
    // }

    uploadConfig = (item: string) => {
        return {
            autoProcessQueue: true,
            acceptedFiles: this.props.acceptedFiles,
            paramName: 'file',
            params: {},
            headers: {
                Authorization: 'Token ' + localStorage.getItem('token'),
                'Port-id': localStorage.getItem('port_id'),
            },
            fileCallback: 'Uploadfile',
            maxFiles: 1,
            timeout: 60 * 60 * 1000,
            maxFilesize: 25 * 1024 * 1024 , // 12GB
            forceChunking: true,
            parallelChunkUploads: true,
            retryChunks: true,
            maxfilesexceeded(file: any) {
                this.removeAllFiles();
                this.addFile(file);
            },
            complete() {
                this.removeAllFiles();
            },
            error: (file: any, error: any) => {
                this.props.showMessageAction({
                    messageType: 'ERROR',
                    message: error.message,
                });
            },
            success: (file: any, response: any) => {
                if (file.status === 'success') {
                    const temp = { ...this.state.item };
                    temp[item] = response.file;
                    temp.extension = response.extension;
                    temp.fileOrignalName = response.fileOrignalName;
    
                    this.setState({
                        item: temp,
                        errors: { ...this.state.errors, file: null },
                    });
    
                    this.props.showMessageAction({
                        messageType: 'INFO',
                        message: translate('File uploaded successfully.'),
                    });
                } else {
                    this.props.showMessageAction({
                        messageType: 'ERROR',
                        message: translate('Error while uploading file.'),
                    });
                }
            },
           
        };
    };
    

    render() {
        return (
            <FormGroup horizontal>
                <Label className="w-32">File</Label>

                <div className="w-full pt-2">
                    {/* @ts-ignore */}
                    <DropzoneComponent
                        config={{
                            postUrl: this.props.url,
                        }}
                        djsConfig={this.uploadConfig('file')}
                    >
                        <input
                            className="w-full h-ful z-10 text-center bg-transparent absolute hidden"
                            disabled
                            value={this.state.item?.fileOrignalName || ''}
                            name="file"
                        />
                    </DropzoneComponent>
                    <p className="text-xs text-gray-600 mt-1">
                        {translate('Accepted files')} ({`${this.props.acceptedFiles}`})
                    </p>
                    {this.props.children}
                </div>
            </FormGroup>
        );
    }
}

const uploadFileStateToProps = (state: RootState) => ({
    language: state.user.language,
});

const uploadFileDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
});

export default connect(uploadFileStateToProps, uploadFileDispatchToProps)(UploadFile);
